import React from 'react'
import BaseBlockContent from '@sanity/block-content-to-react'

const homePageSerializers = {
  types: {
    splashPageSection: ({ node }) => {
      let classes
      switch (node.type) {
        case 'splash':
          classes = 'section section-feature'
          break
        case 'content':
        default:
          classes = 'section page-content'
      }
      return (
        <div className={classes}>
          <div className="content">
            <BaseBlockContent
              blocks={node.content}
              projectId={process.env.GATSBY_SANITY_PROJECT_ID}
              dataset={process.env.GATSBY_SANITY_DATASET}
            />
          </div>
        </div>
      )
    },
  },
}

export default homePageSerializers
